<template>
  <footer class="app-footer">
    <feefo-badge />

    <payment-types />

    <footer-links class="footer-nav">
      <translate
        tag="a"
        :href="`https://www.pitchup.com/${
          $i18n.locale !== 'en-gb' ? $i18n.locale + '/' : ''
        }about/`"
        target="_blank"
      >
        About us
      </translate>
      <nuxt-link :to="$puLocalePath({ name: 'about-faq' })">
        <translate>FAQ</translate>
      </nuxt-link>
      <translate
        tag="a"
        :href="`https://www.pitchup.com/${
          $i18n.locale !== 'en-gb' ? $i18n.locale + '/' : ''
        }join/`"
        target="_blank"
        >Add your campsite</translate
      >
      <translate
        tag="a"
        href="https://pitchup.uservoice.com/forums/4223-help-us-improve-provided-by-uservoice"
        target="_blank"
        >Website feedback</translate
      >
      <button
        class="link"
        type="button"
        :aria-label="$t('My account')"
        @click.prevent="toggleUserAccount"
      >
        <translate>My account</translate>
      </button>
    </footer-links>

    <version />
    <copyright />
  </footer>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({
  setup() {
    return {
      appMenuStore: useAppMenuStore(usePinia()),
    }
  },
})
class AppFooter extends Vue {
  appMenuStore: ReturnType<typeof useAppMenuStore>

  toggleUserAccount() {
    this.appMenuStore.send('SHOW_ACCOUNT_MENU')
  }
}

export default toNative(AppFooter)
</script>

<style scoped>
footer {
  background-color: #f4f6f8;
  width: 100vw;
  min-height: 21em;
}

.footer-nav :deep(a),
.link {
  font-size: var(--body);
  color: var(--colour-dark-blue);
  text-decoration: none;
  padding: 0.6em 1em;
}

.link {
  border: none;
  background: none;
  box-shadow: none;
  border-radius: 0;
  transform: none;
  line-height: normal;
}
</style>
